import { render, staticRenderFns } from "./UserModify.vue?vue&type=template&id=5fd85a5e"
import script from "./UserModify.vue?vue&type=script&lang=js"
export * from "./UserModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports